<template>
  <v-row justify="center">
    <v-dialog v-model="close" width="34%" persistent>
      <v-card>
        <v-card-title color="yellow" class="text-h5">
          {{ title }}
        </v-card-title>
        <v-card-text>{{ message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning-darken-1"
            variant="text"
            @click="handelAlert(false)"
          >
            Cancel
          </v-btn>
          <v-btn
            color="green-darken-1"
            variant="text"
            @click="handelAlert(true)"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: ["title", "message", "show"],
  data() {
    return {};
  },
  methods: {
    handelAlert(confirm) {
      this.$emit("confirm", confirm);
    },
  },
  computed: {
    close() {
      return this.show;
    },
  },
};
</script>
